import { vuexEventPathGenerator } from '@/utils';
const getterType = {
    getterIsAreaDialogOpen: 'getterIsAreaDialogOpen',
    getterDeliveryChargeList: 'getterDeliveryChargeList',
    getterGetStoreId: 'getterGetStoreId',
    getterGetStoreName: 'getterGetStoreName',
    getterPaginationData: 'getterPaginationData',
    getterCheckedList: 'getterCheckedList',
};
export const deliveryChargeGetterType = vuexEventPathGenerator(getterType, 'deliveryChargeDialog');
const getter = {
    [getterType.getterGetStoreName]: ({ storeDetail }) => (storeDetail ? storeDetail.name : ''),
    [getterType.getterGetStoreId]: ({ storeDetail }) => (storeDetail ? storeDetail.id : ''),
    [getterType.getterIsAreaDialogOpen]: ({ isAreaDialogOpen }) => isAreaDialogOpen,
    [getterType.getterDeliveryChargeList]: ({ deliveryChargeList }) => deliveryChargeList,
    [getterType.getterPaginationData]: ({ paginationData }) => paginationData,
    [getterType.getterCheckedList]: ({ checkedList }) => checkedList,
};
export default getter;
